export default __webpack_public_path__ + "static/media/ayo.ab40204d.jpeg";